import { ProductType } from '../constants/productTypes';
import {
  ProductBuilderMachineContext,
  ProductBuilderMachineState,
} from '../types';

type LiningColourStatePostProcess = (
  productType: ProductType,
  context: ProductBuilderMachineContext,
  states: ProductBuilderMachineState[],
) => ProductBuilderMachineState[];

export const pullRodColourPostProcess: LiningColourStatePostProcess = (
  productType,
  context,
  states,
) => {
  const {
    custom: { pullRod },
  } = context;

  const productTypesAllowed: ProductType[] = ['Curtain', 'Sheer Curtain'];
  if (!productType || !productTypesAllowed.includes(productType)) return states;

  return pullRod === 'No Thanks'
    ? states.filter(state => state !== 'pullRodColour')
    : states;
};